/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StageLane/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ArrowDown from 'DesignSystem/Svgs/Tysiav2ArrowDown/index'
import Tysiav2ArrowUp from 'DesignSystem/Svgs/Tysiav2ArrowUp/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function StageLane({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/TasksList/Content/Content/StageLane"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let collapsedStageLanesValueData = fromData.useDataValue({ viewPath,
context: 'collapsed_stage_lanes',
})
let stageIdValueData = fromData.useDataValue({ viewPath,
context: 'stage',
path: 'id',
})
let aggregateData = fromAggregate.includes(collapsedStageLanesValueData, stageIdValueData)
let collapsedStageLanesValueData1 = fromData.useDataValue({ viewPath,
context: 'collapsed_stage_lanes',
})
let stageIdValueData1 = fromData.useDataValue({ viewPath,
context: 'stage',
path: 'id',
})
let aggregateData1 = fromAggregate.includes(collapsedStageLanesValueData1, stageIdValueData1)
let stageNameValueData = fromData.useDataValue({ viewPath,
context: 'stage',
path: 'name',
})
  return (<React.Fragment
>
<button
  data-testid="StageLane.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--g-1-ZwNGgn': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={aggregateData}>
<Tysiav2ArrowUp
  viewPath={`${viewPath}/Tysiav2ArrowUp`}
 data="collapsed_stage_lanes"
 data="stage.id"
 aggregate="/Data/aggregate includes"
/>
</fromFlow.When>
<fromFlow.When is={!aggregateData1}>
<Tysiav2ArrowDown
  viewPath={`${viewPath}/Tysiav2ArrowDown`}
 data="collapsed_stage_lanes"
 data="stage.id"
 aggregate="/Data/aggregate includes"
/>
</fromFlow.When>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="stage.name"
 text={stageNameValueData}
 fontSize={16}
 fontWeight={500}
/>
</button>
{children}
</React.Fragment>)
}